module.exports = __webpack_public_path__ + "static/media/missed-penalty.0a71cc6b.svg";